import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '@environments/environment';
import { LoggerService } from '@services/logger.service';
import { ResolverService } from '@services/resolver.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
})

export class AppComponent {
  private resolverService = inject(ResolverService);
  private destroyRef = inject(DestroyRef);
  private titleService = inject(Title);
  private document = inject(DOCUMENT);

  private hash!: string;
  protected showLoader = true;

  ngOnInit(): void {
    this.titleService.setTitle(environment.appName);
    this.setFavicon();
    this.hash = window.location.pathname?.split('/')?.[1];
    if (!this.hash) {
      this.showLoader = false;
      return;
    }
    this.resolveUrl();
  }

  private setFavicon(): void {
    const link = this.document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (link) {
      link.href = environment.faviconPath;
    }
  }

  private resolveUrl(): void {
    this.resolverService.validateHash(this.hash)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: result => {
          result?.url && (window.location.href = result.url);
        },
        error: (error: HttpErrorResponse) => {
          this.showLoader = false;
          LoggerService.error(error);
        },
      });
  }
}
